/*
 *  Copyright © 2026 Cenozon Inc. All Rights Reserved.
 */

/**
 * Where to send someone back to after authentication.
 *
 * The app routes on the hash (HashRouter), so the pathname alone names no screen:
 * returning `/` or `/help` puts every deep link on the default destination, which is
 * what a recipient sees when they open a shared link in a cold tab. The hash has to
 * come with it.
 *
 * The query string is deliberately left out. On the way back from the provider it
 * carries the OIDC `code` and `state`, and returning those would put spent
 * credentials into the address bar and into browser history.
 *
 * @param {Location} [location] injectable for tests
 * @returns {string} pathname and hash, no query string
 */
export const returnUri = (location = window.location) =>
   `${location.pathname}${location.hash}`;
